const availableOptions = {
  ExPt: ["prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  WhMo: ["f50", "gt3", "s3", "kpr", "ngo", "ngo2"],
  WhCo: ["hs", "wh", "wg", "bl", "an", "br"],
  BrCo: ["prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  TiMo: ["to", "mi"],
  FrLi: ["wcf", "fcf", "prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  FeLo: ["wcf", "fcf", "prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  SiSk: ["wcf", "fcf", "prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  SiBl: ["wcf", "fcf", "prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  MiCa: ["wcf", "fcf", "prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  ReDi: ["wcf", "fcf", "prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  SpAc: ["on", "off"],
  SpCo: ["wcf", "fcf", "prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  SpPl: ["wcf", "fcf", "prm", "kgm", "abm", "mbm", "pym", "dgp", "aw", "kg"],
  ExTp: ["1", "2"],
  ExMa: ["ss", "ti", "in", "cc"],
  // Combined the 'InCo' options into one array, as they share the same group key.
  InCo: [
    "leblbl",
    "leblbr",
    "leblre",
    "leblta",
    "lenbnb",
    "lenbbl",
    "alblbl",
    "alblbr",
    "alblre",
    "alblta",
    "alnbnb",
    "alnbbl",
  ],
};

const lastChosenOption = new Map();

const getRandomUniqueChoice = (groupKey, choices) => {
  if (choices.length <= 1) {
    return choices[0];
  }

  const lastChoice = lastChosenOption.get(groupKey);
  let randomIndex;
  let newChoice;

  // Loop until we find a choice that is NOT the same as the last one
  do {
    randomIndex = Math.floor(Math.random() * choices.length);
    newChoice = choices[randomIndex];
  } while (newChoice === lastChoice);

  // Update the persistent map with the new choice
  lastChosenOption.set(groupKey, newChoice);

  return newChoice;
};

export const generateRandomConfiguration = (options = availableOptions) => {
  const configuration = {};

  // Define the synchronized groups
  const groupAKeys = ["FrLi", "SiSk", "ReDi", "SpPl"];
  const groupBKeys = ["FeLo", "SiBl", "MiCa", "SpCo"];
  const synchronizedKeys = [...groupAKeys, ...groupBKeys];

  // Keys that MUST NOT repeat immediately (ExPt, Group A, Group B)
  const uniqueRequiredKeys = ["ExPt", ...synchronizedKeys];

  // --- A. Handle ExPt (Single Unique Key) ---
  const exPtChoices = options["ExPt"];
  configuration["ExPt"] = getRandomUniqueChoice("ExPt", exPtChoices);

  // --- B. Handle Synchronized Groups (Group A and Group B) ---

  // Group A: FrLi, SiSk, ReDi, SpPl
  const groupAChoices = options[groupAKeys[0]];
  // Get ONE unique choice for the whole group A, based on the first key as tracker
  const randomAChoice = getRandomUniqueChoice(groupAKeys[0], groupAChoices);

  for (const key of groupAKeys) {
    configuration[key] = randomAChoice;
    // Since all keys in the group get the same value, update the tracker for ALL of them
    lastChosenOption.set(key, randomAChoice);
  }

  // Group B: FeLo, SiBl, MiCa, SpCo
  const groupBChoices = options[groupBKeys[0]];
  const randomBChoice = getRandomUniqueChoice(groupBKeys[0], groupBChoices);

  for (const key of groupBKeys) {
    configuration[key] = randomBChoice;
    // Update the tracker for ALL keys in Group B
    lastChosenOption.set(key, randomBChoice);
  }

  // --- C. Handle All Other Independent Keys (Repetition Allowed) ---

  const allKeys = Object.keys(options);
  const independentKeys = allKeys.filter(
    (key) => !uniqueRequiredKeys.includes(key)
  );

  for (const groupKey of independentKeys) {
    const choices = options[groupKey];

    // Use basic random selection (allows immediate repetition)
    const randomIndex = Math.floor(Math.random() * choices.length);
    configuration[groupKey] = choices[randomIndex];
  }

  return configuration;
};
